import services from '@/config/services'
import FileManager from '@/services/ask-file-manager/index.js'

export default class PanelAdminService {
  constructor(http, eventBus) {
    this.http = http
    this.eventBus = eventBus
    this.baseUrl = `${services.ask_api.url}/management/panel-admin`
    this.flussiUrl = `${services.ask_base_flussi.url}`
    this.praticheUrl = `${services.ask_pratiche_base.url}/api`
    this.filemanager = new FileManager()
  }

  async getDocumentiIdentitaRappresentanteDaAllineare(page) {
    const res = await this.http.get(`${this.praticheUrl}/pratiche/v1/rappresentanti/documenti-identita/da-allineare`, { params: { page } })
    return res.data
  }

  async allineaDocumentoIdentitaRappresentante(matriceId, rappresentanteId) {
    const res = await this.http.post(`${this.praticheUrl}/pratiche/v1/rappresentanti/documenti-identita/allinea`, { matrice_id: matriceId, rappresentante_id: rappresentanteId })
    return res.data
  }

  async processAnnullamentiApnSelezionati(ids) {
    try {
      const res = await this.http.post(this.praticheUrl + '/pratiche/v1/multisito/data/process-annullamenti-apn-selezionati', {
        ids_pratica_annullamento: ids,
      })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getPuntiSwitchatiConApnByMonth(params) {
    try {
      const res = await this.http.get(this.praticheUrl + '/pratiche/v1/multisito/data/get-punti-switchati-con-apn-by-month', { params })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async riportaContrattoInValidazione(idMatrice) {
    const url = `${this.baseUrl}/riporta-contratto-in-validazione`
    const payload = { id_matrice: idMatrice }

    try {
      const res = await this.http.get(url, {
        headers: {
          'Content-Type': 'application/json'
        },
        params: payload
      })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async confirmValidationMatrice(idMatrice) {
    const url = `${this.baseUrl}/confirm-validation-matrice`
    const payload = { id_matrice: idMatrice }

    try {
      const res = await this.http.get(url, {
        headers: {
          'Content-Type': 'application/json'
        },
        params: payload
      })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async resetEsitoSdiContabilita(numero) {
    const url = `${this.baseUrl}/reset-esito-sdi-contabilita`
    const payload = { numero }

    try {
      const res = await this.http.get(url, {
        headers: {
          'Content-Type': 'application/json'
        },
        params: payload
      })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getCanSearchNextValidation() {
    const url = `${this.baseUrl}/get-can-search-next-validation`

    try {
      const res = await this.http.get(url)
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }
  async getComuniRemi() {
    const url = `${this.baseUrl}/get-comuni-remi`

    try {
      const res = await this.http.get(url)
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getStoricoCaricamento(id){
    const url = `${this.baseUrl}/get-storico-caricamento-by-id/${id}`

    try {
      const res = await this.http.get(url)
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async detachContractSignature(matriceId, signatureId) {
    const res = await this.http.post(this.flussiUrl + '/eSign/detach-contract-signature', {
      matrice_id: matriceId, cod_richiesta_firma: signatureId
    })
    return res.data
  }

  async resetCaricamento(id, status){
    const url = `${this.baseUrl}/reset-caricamento/${id}/${status}`

    try {
      const res = await this.http.get(url)
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getPPwithoutCTR(){
    const url = `${this.baseUrl}/get-pp-without-ctr`

    try {
      const res = await this.http.get(url)
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }
  async allineaPPtoCTR(){
    const url = `${this.baseUrl}/allinea-pp-to-ctr`

    try {
      const res = await this.http.get(url)
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async allineaDataInizio(ids){
    const url = `${this.baseUrl}/allinea-data-inizio-fornitura-contratto`

    try {
      const res = await this.http.post(url, {
        ids
      })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async addRemiToComune(idComune, remi){
    const url = `${this.baseUrl}/add-remi-to-comune`

    try {
      const res = await this.http.post(url, {
        idComune,
        remi
      })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async addCodiceDestinatarioSdi(sdi){
    const url = `${this.baseUrl}/add-codice-destinatario-sdi`

    try {
      const res = await this.http.post(url, {
        sdi
      })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async setActiveCanSearchNextValidation() {
    const url = `${this.baseUrl}/set-active-can-search-next-validation`

    try {
      const res = await this.http.get(url)
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getFullProcesslist() {
    const url = `${this.baseUrl}/get-full-processlist`

    try {
      const res = await this.http.get(url)
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async killProcessById(processId, psw) {
    const url = `${this.baseUrl}/kill-process-by-id`

    try {
      const res = await this.http.get(url, {
        params: {
          process_id: processId,
          psw
        }
      })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async createPswListProcess(psw) {
    const url = `${this.baseUrl}/create-psw-list-process`

    try {
      const res = await this.http.post(url, {
        psw
      })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async checkPswListProcess() {
    const url = `${this.baseUrl}/check-psw-list-process`

    try {
      const res = await this.http.get(url)
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async exportNumeriFatturaContabilitaCsv(startDate, endDate) {
    const url = `${this.baseUrl}/export-numeri-fattura`

    try {
      const res = await this.http.post(url, {
        start_date: startDate,
        end_date: endDate
      }, {
        responseType: 'blob'
      })
      this.filemanager.download(res, { type: 'text/csv' })
      return true
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async validaFatturePoste(numeriFattura) {
    const url = `${this.baseUrl}/valida-fatture-poste`

    try {
      const res = await this.http.post(url, {
        numeri_fattura: numeriFattura,
      })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async validaContattoFatturaPoste(payload) {
    const url = `${this.baseUrl}/valida-contatto-fattura-poste`

    try {
      const res = await this.http.post(url, payload)
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async aggiornaContattoFatturaPoste(payload) {
    const url = `${this.baseUrl}/aggiorna-contatto-fattura-poste`

    try {
      const res = await this.http.post(url, payload)
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getFattureNonInviateDaProcessare() {
    const url = `${this.baseUrl}/get-fatture-non-inviate-da-processare`

    try {
      const res = await this.http.get(url)
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getFilePraticheDaRecuperare(month, withoutLimit = false) {
    const url = `${this.praticheUrl}/pratiche/v1/multisito/data/get-file-pratiche-da-recuperare`

    try {
      const res = await this.http.get(url, {
        params: { month, limit: withoutLimit ? 'all' : 20 }
      })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getPayloadIdCaricamentiByMonth(month, withoutLimit = false) {
    const url = `${this.praticheUrl}/pratiche/v1/multisito/data/get-payload-id-caricamenti-by-month`

    try {
      const res = await this.http.get(url, {
        params: { month, limit: withoutLimit ? 'all' : 20 }
      })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async updatePayloadIdCaricamenti(items) {
    const url = `${this.praticheUrl}/pratiche/v1/multisito/data/update-payload-id-caricamenti`

    try {
      const res = await this.http.post(url, { items })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getSwitchDateLogRetroattiviByValidationMonth(month, withoutLimit = false) {
    const url = `${this.praticheUrl}/pratiche/v1/multisito/data/get-switch-date-log-retroattivi-by-validation-month`

    try {
      const res = await this.http.get(url, {
        params: { month, limit: withoutLimit ? 'all' : 20 }
      })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getMatriciSenzaSwitchByMonth(month, withoutLimit = false) {
    const url = `${this.praticheUrl}/pratiche/v1/multisito/data/get-matrici-senza-switch-by-month`

    try {
      const res = await this.http.get(url, {
        params: { month, limit: withoutLimit ? 'all' : 20 }
      })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async createMatriciSwitchMancanti(items) {
    const url = `${this.praticheUrl}/pratiche/v1/multisito/data/create-matrici-switch-mancanti`

    try {
      const res = await this.http.post(url, { items })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async createSwitchDateLogRetroattivi(items) {
    const url = `${this.praticheUrl}/pratiche/v1/multisito/data/create-switch-date-log-retroattivi`

    try {
      const res = await this.http.post(url, { items })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async updateFilePraticheDaRecuperare(items) {
    const url = `${this.praticheUrl}/pratiche/v1/multisito/data/update-file-pratiche-da-recuperare`

    try {
      const res = await this.http.post(url, { items })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async forzaScissionePkMassiva(ids) {
    const url = `${this.praticheUrl}/pratiche/v1/multisito/forza-scissione-pk-massiva`

    try {
      const res = await this.http.post(url, { ids })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async cronForzaScissionePkMassiva() {
    const url = `${this.praticheUrl}/cron-forza-scissione-pk-massiva`

    try {
      const res = await this.http.get(url)
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getValidazioniPrenotate() {
    const url = `${this.baseUrl}/get-validazioni-prenotate`

    try {
      const res = await this.http.get(url)
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async deleteValidazionePrenotata(id) {
    const url = `${this.baseUrl}/delete-validazione-prenotata`

    try {
      const res = await this.http.post(url, {id})
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getCategoryMotivationTicket() {
    const url = `${this.baseUrl}/get-category-motivation-ticket`

    try {
      const res = await this.http.get(url)
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async addNewCategoryTicket(motivation, canViewAgente = 0) {
    const url = `${this.baseUrl}/add-new-category-ticket`

    try {
      const res = await this.http.post(url, {
        motivation,
        can_view_agente: canViewAgente ? 1 : 0,
      })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async deleteCategoryMotivationTicket(ids) {
    const url = `${this.baseUrl}/delete-category-motivation-ticket`

    try {
      const res = await this.http.post(url, { ids })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getCheckExistReportAgents() {
    try {
      const res = await this.http.get(`${this.praticheUrl}/pratiche/v1/get-agenti`)
      return { items: Array.isArray(res.data) ? res.data : [] }
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getCheckExistReportPreview(filters = {}) {
    const url = `${this.praticheUrl}/cron-report-call-check-exist`

    try {
      const res = await this.http.get(url, { params: { ...filters, preview: 1 } })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async createContratti() {
    const url = `${this.praticheUrl}/crea-contratti`

    try {
      const res = await this.http.get(url, {
        params: { async_response: 1 },
        timeout: 10000
      })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getCreateContrattiCount() {
    const url = `${this.praticheUrl}/crea-contratti/count`

    try {
      const res = await this.http.get(url)
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  getLogsBaseUrl(project = 'ask_pratiche') {
    if (project === 'ask_flussi') return this.flussiUrl + '/logs'
    if (project === 'ask_pratiche') return this.praticheUrl + '/pratiche/v1/logs'
    throw new Error('Progetto log non valido')
  }

  async getLogTypes(onProjectLoaded) {
    const projects = ['ask_pratiche', 'ask_flussi']
    try {
      const results = await Promise.allSettled(projects.map(async project => {
        let result
        try {
          const response = await this.http.get(this.getLogsBaseUrl(project) + '/types')
          if (!Array.isArray(response.data?.items)) throw new Error('Catalogo log non valido')
          result = {
            project,
            items: response.data.items.map(log => ({ ...log, project, base_name: log.base_name || log.type })),
            unavailable: false
          }
        } catch {
          result = { project, items: [], unavailable: true }
        }
        if (onProjectLoaded) onProjectLoaded(result)
        return result
      }))
      const items = []
      const failed_projects = []
      results.forEach((result, index) => {
        if (result.status === 'fulfilled' && !result.value.unavailable) {
          items.push(...result.value.items)
        } else failed_projects.push(projects[index])
      })
      return { items, failed_projects }
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getMatriciIndexClienteIdMancante() {
    const url = `${this.praticheUrl}/pratiche/v1/multisito/data/get-matrici-index-cliente-id-mancante`

    try {
      const res = await this.http.get(url)
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async updateMatriciIndexClienteId(items) {
    const url = `${this.praticheUrl}/pratiche/v1/multisito/data/update-matrici-index-cliente-id`

    try {
      const res = await this.http.post(url, { items })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getMatriciIndexRappresentanteIdMancante() {
    const url = `${this.praticheUrl}/pratiche/v1/multisito/data/get-matrici-index-rappresentante-id-mancante`

    try {
      const res = await this.http.get(url)
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async updateMatriciIndexRappresentanteId(items) {
    const url = `${this.praticheUrl}/pratiche/v1/multisito/data/update-matrici-index-rappresentante-id`

    try {
      const res = await this.http.post(url, { items })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getCaricamentiMatriceIndexStoricoDuplicatoStato2() {
    const url = `${this.praticheUrl}/pratiche/v1/multisito/data/get-caricamenti-matrice-index-storico-duplicato-stato-2`

    try {
      const res = await this.http.get(url)
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async deleteMatriceIndexStorico(id) {
    const url = `${this.praticheUrl}/pratiche/v1/multisito/data/delete-matrice-index-storico`

    try {
      const res = await this.http.post(url, { id })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async updateMatriceSupplyClienteIdRecuperato(type, id, idRecuperato) {
    const url = `${this.praticheUrl}/pratiche/v1/multisito/data/update-matrice-supply-cliente-id-recuperato`

    try {
      const res = await this.http.post(url, {
        type,
        id,
        id_recuperato: idRecuperato,
      })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getLogFiles(type, project = 'ask_pratiche') {
    const url = `${this.getLogsBaseUrl(project)}/${encodeURIComponent(type)}`

    try {
      const res = await this.http.get(url)
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async searchLogFiles(type, query, project = 'ask_pratiche') {
    const url = `${this.getLogsBaseUrl(project)}/search/${encodeURIComponent(type)}`

    try {
      const res = await this.http.get(url, {
        params: { search: query }
      })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getLogFileContent(filename, project = 'ask_pratiche') {
    const url = `${this.getLogsBaseUrl(project)}/file-content`

    try {
      const res = await this.http.get(url, {
        params: { filename }
      })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getLogFileTail(filename, options = {}, project = 'ask_pratiche') {
    const url = `${this.getLogsBaseUrl(project)}/file-tail`

    try {
      const params = {
        filename,
        lines: options.lines || 100,
      }

      if (options.offset !== null && options.offset !== undefined) {
        params.offset = options.offset
      }

      const res = await this.http.get(url, { params })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getExternalNews() {
    const url = `${this.baseUrl}/external-news`
    try {
      const res = await this.http.get(url)
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async createExternalNews(payload) {
    const url = `${this.baseUrl}/external-news`
    try {
      const res = await this.http.post(url, payload)
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async updateExternalNews(id, payload) {
    const url = `${this.baseUrl}/external-news/${id}`
    try {
      const res = await this.http.put(url, payload)
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async deleteExternalNews(id) {
    const url = `${this.baseUrl}/external-news/${id}`
    try {
      const res = await this.http.delete(url)
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async setExternalNewsVisibility(id, visible) {
    const url = `${this.baseUrl}/external-news/${id}/visibility`
    try {
      const res = await this.http.post(url, { visible: visible ? 1 : 0 })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async listRichiesteFerie(params = {}) {
    const url = `${this.baseUrl}/list-richieste-ferie`
    try {
      const res = await this.http.get(url, { params })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async createRichiestaFerie(payload) {
    const url = `${this.baseUrl}/create-richiesta-ferie`
    try {
      const res = await this.http.post(url, payload, {
        headers: { 'Content-Type': 'application/json' },
      })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async gestisciRichiestaFerie(payload) {
    const url = `${this.baseUrl}/gestisci-richiesta-ferie`
    try {
      const res = await this.http.post(url, payload, {
        headers: { 'Content-Type': 'application/json' },
      })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async revocaRichiestaFerie(payload) {
    const url = `${this.baseUrl}/revoca-richiesta-ferie`
    try {
      const res = await this.http.post(url, payload, {
        headers: { 'Content-Type': 'application/json' },
      })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getRecallClientCalendar(params = {}) {
    const url = `${this.baseUrl}/get-recall-client`
    try {
      const res = await this.http.get(url, { params })
      return res.data
    } finally {
      this.eventBus.emit('data-loaded')
    }
  }

  async getRecallClientTodayCount() {
    const url = `${this.baseUrl}/get-recall-client`
    try {
      const res = await this.http.get(url, { params: { summary: 1 } })
      return Number(res?.data?.today_count || 0)
    } catch (error) {
      return 0
    }
  }
}
